import React from 'react';
import { connect } from 'react-redux';

import { required } from '../../../../utils/form-validation';

import {
    Select,
} from '../../../Form';

const SelectHSEventType = (props) => {
    const {
        field,
        value,
        onChange,
        editing,
        coreUI,
    } = props;

    const { hsEventTypes } = coreUI.types.tms;

    return (
        <div className={`col-12 mb24`}>
            <div className="div div16" />
            {/* <ToggleSwitch
                id={'hsEventType'}
                field={field}
                formGroupCssClass={`mt16`}
                label="Is this an official High School event or a fundraiser/other event?"
                reverse={false}
            /> */}
            <div className={`d-flex align-items-start`}>
                <div className={`flex-2`}>
                    <div className={`form-group form-group-xl mb0`}>
                        <label htmlFor={'hsEventType'} data-testid="selecthseventtype.label-34">
                            {'Is this an official High School event or a fundraiser/other event?'}
                        </label>
                    </div>
                </div>
                <div className={`flex-1`}>
                    <Select
                        id="hsEventType"
                        formGroupCssClass={`mb0`}
                        field={field}
                        value={value}
                        options={hsEventTypes}
                        onChange={(val) => {
                            if (onChange) {
                                onChange(val);
                            }
                        }}
                        validate={required}
                        hiddenLabel={true}
                        disabled={editing}
                        data-testid="event-edit.hs-event-type-select"
                    />
                </div>
            </div>
        </div>
    );
};

function mapStateToProps({ coreUI }) {
    return { coreUI };
}

export default connect(mapStateToProps)(SelectHSEventType);
